import { DisplayConfigFromJSON, DisplayConfigToJSON, } from './DisplayConfig';
import { SalesConfigFromJSON, SalesConfigToJSON, } from './SalesConfig';
import { StripeBillingConfigFromJSON, StripeBillingConfigToJSON, } from './StripeBillingConfig';
/**
 * Check if a given object implements the StripeProduct interface.
 */
export function instanceOfStripeProduct(value) {
    let isInstance = true;
    isInstance = isInstance && "isInternal" in value;
    isInstance = isInstance && "displayConfig" in value;
    isInstance = isInstance && "isPublished" in value;
    isInstance = isInstance && "billingConfig" in value;
    isInstance = isInstance && "salesConfig" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "goodsIds" in value;
    return isInstance;
}
export function StripeProductFromJSON(json) {
    return StripeProductFromJSONTyped(json, false);
}
export function StripeProductFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isInternal': json['isInternal'],
        'displayConfig': DisplayConfigFromJSON(json['displayConfig']),
        'isPublished': json['isPublished'],
        'billingConfig': StripeBillingConfigFromJSON(json['billingConfig']),
        'salesConfig': SalesConfigFromJSON(json['salesConfig']),
        'id': json['id'],
        'goodsIds': json['goodsIds'],
    };
}
export function StripeProductToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'isInternal': value.isInternal,
        'displayConfig': DisplayConfigToJSON(value.displayConfig),
        'isPublished': value.isPublished,
        'billingConfig': StripeBillingConfigToJSON(value.billingConfig),
        'salesConfig': SalesConfigToJSON(value.salesConfig),
        'id': value.id,
        'goodsIds': value.goodsIds,
    };
}
